




































































































import { checklistPostReq } from "@/services/checklist.service";
import {
  companySelection,
  serverFailure,
  visibilitySyncFeedback,
} from "@/services/checklist_settings";

export default {
  props: ["cl_item"],
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      create_error: false,
      database_entry: "",
      cl_entry: {},
      checkbox: true,
      select_user: [],
      select_company: [],
      select_view_company: [],
      select_machine_group: "internal", 
      items_user: [],
      items_company: [],
      items_machine_groups: ['public', 'internal'], 
      update_progress: false,
      status_saved: false,
      // loading, loaded oder failed. Speichern schreibt die Auswahl live nach
      // Inspect, eine nicht geladene leere Auswahl hiesse "für alle sichtbar".
      load_state: "loading",
      save_feedback: null,
      save_error: "",
    };
  },
  watch: {},
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
    canSave: function() {
      return this.load_state == "loaded" && !this.update_progress && !this.status_saved
    },
  },
  mounted() {
    checklistPostReq("checklist-settings", { uid: this.cl_item.uid })
      .then((resp) => {
        this.items_user = resp.data.user_list;
        this.items_company = resp.data.company_list;

        this.select_machine_group = resp.data.select_machine_group
        this.setUsers(resp.data.entry.user_list);
        this.setCompanies(resp.data.entry.company_list);
        console.log(resp.data);
        this.load_state = "loaded";
      })
      .catch((e) => {
        this.load_state = "failed";
        this.$store.dispatch("api_error", e);
      });
  },
  destroyed() {},
  methods: {
    setUsers: function (user_list) {
      this.select_user = [];
      if (user_list) {
        for (let k = 0; k < user_list.length; k++) {
          for (let m = 0; m < this.items_user.length; m++) {
            if (this.items_user[m].uid == user_list[k]) {
              console.log(this.items_user[m]);
              this.select_user.push({
                uid: this.items_user[m].uid,
                name: this.items_user[m].name,
              });
            }
          }
        }
      }
    },
    setCompanies: function (company_list) {
      const companies = companySelection(company_list, this.items_company, this.companyFallbackName);
      this.items_company = companies.items;
      this.select_company = companies.selected;
    },
    companyFallbackName: function (company_id) {
      if (company_id === null || company_id === undefined || company_id === "") {
        return this.$t('CHECKLIST_SETTINGS.COMPANY_NO_ID');
      }
      return this.$t('CHECKLIST_SETTINGS.COMPANY_UNKNOWN', { id: company_id });
    },
    closeDialog: function () {
      if (this.update_progress) {
        return;
      }
      this.$emit("dialogClosed", true);
    },
    save: function () {
      //if (!this.select_user || this.select_user.length == 0) {
      //  alert(this.$t('LABEL78'));
      //  return;
      //}

      if (!this.canSave) {
        return;
      }

      this.update_progress = true;
      this.save_feedback = null;
      this.save_error = "";
      checklistPostReq("checklist-update-settings", {
        uid: this.cl_item.uid,
        select_user: this.select_user,
        select_company: this.select_company,
        //select_view_company: this.select_view_company,
        select_machine_group: this.select_machine_group,
      })
        .then((resp) => {
          this.update_progress = false;
          this.save_feedback = visibilitySyncFeedback(resp.data && resp.data.visibility_sync);
          this.status_saved = !this.save_feedback.retry;
        })
        .catch((e) => {
          this.update_progress = false;
          const failure = serverFailure(e);
          this.save_error = (failure && failure.message) || this.$t('CHECKLIST_SETTINGS.SAVE_FAILED');
          if (!failure) {
            this.$store.dispatch("api_error", e);
          }
        });
    },
  },
};
